/* ==========================================================================
   SOLUNA CURAÇAO — Theme JS (vanilla, no frameworks)
   ========================================================================== */

(function () {
  'use strict';

  /* Mobile navigation
     ======================================================================== */
  const navToggle = document.getElementById('nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const navClose = document.getElementById('nav-close');

  function openMobileNav() {
    mobileNav.classList.add('is-open');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    navClose && navClose.focus();
  }

  function closeMobileNav() {
    mobileNav.classList.remove('is-open');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    navToggle && navToggle.focus();
  }

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.contains('is-open');
      isOpen ? closeMobileNav() : openMobileNav();
    });

    if (navClose) {
      navClose.addEventListener('click', closeMobileNav);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeMobileNav();
      }
    });

    /* Close when a nav link is tapped on mobile */
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav);
    });
  }

  /* FAQ accordion
     ======================================================================== */
  document.querySelectorAll('.faq-question').forEach(function (question) {
    question.addEventListener('click', function () {
      const item = question.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');

      /* Close all open items first */
      document.querySelectorAll('.faq-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Tours carousel (homepage & tours page)
     ======================================================================== */
  const track = document.getElementById('tours-track');
  const prevBtn = document.getElementById('tours-prev');
  const nextBtn = document.getElementById('tours-next');
  const dots = document.querySelectorAll('.carousel-dot');

  function getCardWidth() {
    const card = track && track.querySelector('.tour-card');
    if (!card) return 0;
    const gap = 20;
    return card.offsetWidth + gap;
  }

  function updateCarouselState() {
    if (!track) return;
    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;

    if (dots.length) {
      const index = Math.min(
        Math.round(track.scrollLeft / getCardWidth()),
        dots.length - 1
      );
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }
  }

  function setMobileCardWidth() {
    if (!track) return;
    const isMobile = window.innerWidth < 768;
    track.querySelectorAll('.tour-card').forEach(function (card) {
      card.style.flex = isMobile ? '0 0 80%' : '';
    });
    updateCarouselState();
  }

  if (track) {
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateCarouselState, { passive: true });
    window.addEventListener('resize', setMobileCardWidth);
    setMobileCardWidth();
  }

  /* Booking popup
     ======================================================================== */
  var DURATIONS = [
    { label: '1 hour',    price: '€150', message: 'Seadoo Tour — 1 hour' },
    { label: '2 hours',   price: '€275', message: 'Seadoo Tour — 2 hours' },
{ label: 'Halve dag',     price: '€500', message: 'Seadoo Tour — Halve dag', min2: true },
{ label: 'Spaanse Water', price: '€750', message: 'Seadoo Half Day — Spaanse Water', min2: true },
{ label: 'Fuikdag',       price: null,   message: 'Seadoo Tour — Fuikdag' }  ];

  var PERSONS_OPTIONS = ['1', '2', '3', '4', '5+'];

  var FAQ_ITEMS = [
    { q: 'How can I pay for my booking?',
      a: 'Payments can be made securely online during the booking process using major credit and debit cards.' },
    { q: 'Are your guides certified to operate on Curaçao\'s waters?',
      a: 'Yes, all our guides are fully certified and hold the required boating licenses to operate on the inland waters of Curaçao. Your safety and compliance with local regulations are our top priorities.' },
    { q: 'How can I stay updated?',
      a: 'Follow us on social media to see the latest tours, behind-the-scenes content, and updates on our upcoming stays.' },
    { q: 'Can we combine this with accommodation?',
      a: 'Yes — we\'re currently working on exclusive stays to complete your experience. Follow us on social media to be the first to know when our accommodations go live.' },
    { q: 'What is your cancellation policy?',
      a: 'We offer flexible rescheduling options. If cancellation is necessary, our policy will be clearly communicated during booking to keep everything simple and transparent.' },
    { q: 'What happens in case of bad weather?',
      a: 'If weather conditions are not safe, we will always reschedule your tour. If rescheduling isn\'t possible, you will receive a full refund.' },
    { q: 'Where do the tours start?',
      a: 'All our tours start from a carefully selected location, chosen for the best combination of safety, scenery, and easy access. You\'ll receive the exact location and directions after booking.' },
    { q: 'Do I need a license to drive a jet ski?',
      a: 'No license is required. Before the tour, our guides will give you a full safety briefing and instructions, so you\'ll feel confident and ready to ride.' },
    { q: 'What should I bring?',
      a: 'We recommend bringing swimwear, a towel, sunscreen, and sunglasses with a strap. A waterproof phone case or camera is also a great idea. We\'ll take care of the rest.' },
    { q: 'Is it safe?',
      a: 'Safety is our top priority. Our experienced guides, high-quality equipment, and clear instructions ensure a safe and enjoyable experience for everyone.' },
    { q: 'Is there an age or weight limit?',
      a: 'Drivers must be at least 16 years old. Younger guests are welcome as passengers when accompanied by an adult. For safety reasons, there is a maximum weight per jet ski.' }
  ];

  var WA_NUMBER = '59996672906';
  var selectedDurationIndex = 0;
  var selectedPersons = '1';

  /* Build popup DOM once and append to body */
  var overlay = document.createElement('div');
  overlay.className = 'booking-popup-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'booking-popup-heading');
  overlay.setAttribute('aria-hidden', 'true');

  overlay.innerHTML = [
    '<div class="booking-popup">',
      '<button class="booking-popup__close" aria-label="Close booking popup" id="booking-popup-close">&#215;</button>',
      '<p class="booking-popup__eyebrow">Curaçao &middot; Jetski Tours</p>',
      '<h2 class="booking-popup__heading" id="booking-popup-heading">Book a Seadoo Tour</h2>',

      '<p class="booking-popup__label">Select duration</p>',
      '<div class="booking-popup__durations" id="booking-popup-durations"></div>',

      '<p class="booking-popup__label">Number of persons</p>',
      '<div class="booking-popup__persons" id="booking-popup-persons"></div>',

      '<div class="booking-popup__price" id="booking-popup-price"></div>',
'<p class="pdp__booking-note pdp__booking-note--extra" id="booking-popup-extra-note">+ &euro;25 per extra person per jetski</p>',      '<p class="booking-popup__note">We will confirm the date and time via WhatsApp</p>',

      '<a href="#" class="booking-popup__wa-btn" id="booking-popup-wa" target="_blank" rel="noopener">',
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">',
          '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>',
          '<path d="M12 0C5.373 0 0 5.373 0 12c0 2.136.564 4.14 1.547 5.874L.057 23.428a.75.75 0 0 0 .915.915l5.554-1.49A11.94 11.94 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.716 9.716 0 0 1-4.96-1.36l-.355-.212-3.683.988.988-3.608-.233-.374A9.718 9.718 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/>',
        '</svg>',
        'Book via WhatsApp',
      '</a>',

      '<div class="booking-popup__more-info">',
        '<button type="button" class="booking-popup__more-info-toggle" aria-expanded="false" id="booking-popup-more-toggle">',
          'More information <span class="booking-popup__more-info-arrow" aria-hidden="true">&#9660;</span>',
        '</button>',
        '<div class="booking-popup__more-info-content" id="booking-popup-more-content" hidden>',
          '<p class="booking-popup__more-info-text">The ultimate jetski experience along Curaçao\'s stunning coastline. This extended ride takes you further, deeper, and wilder — from hidden beaches to iconic viewpoints, with plenty of time for swimming, snorkeling, cliff jumping, and unforgettable photo moments. This is not just a tour, it\'s a full ocean adventure designed for those who want to experience it all.</p>',
          '<ul class="booking-popup__more-info-list">',
            '<li>Fuel included</li>',
            '<li>Introduction &amp; safety briefing</li>',
            '<li>Photos &amp; video available</li>',
            '<li>Up to 10 beaches &amp; highlights</li>',
            '<li>Cliff jumping available</li>',
            '<li>Snorkeling with turtles</li>',
            '<li>Drone footage — for those who want to experience it all</li>',
          '</ul>',
        '</div>',
      '</div>',

      '<div class="booking-popup__more-info">',
        '<button type="button" class="booking-popup__more-info-toggle" aria-expanded="false" id="booking-popup-faq-toggle">',
          'Frequently asked questions <span class="booking-popup__more-info-arrow" aria-hidden="true">&#9660;</span>',
        '</button>',
        '<div class="booking-popup__more-info-content" id="booking-popup-faq-content" hidden>',
          '<div id="booking-popup-faq-items"></div>',
        '</div>',
      '</div>',

    '</div>'
  ].join('');

  document.body.appendChild(overlay);

  var durationsContainer = document.getElementById('booking-popup-durations');
  var personsContainer   = document.getElementById('booking-popup-persons');
  var faqContainer       = document.getElementById('booking-popup-faq-items');
  var priceEl            = document.getElementById('booking-popup-price');
  var waBtn              = document.getElementById('booking-popup-wa');
  var closeBtn           = document.getElementById('booking-popup-close');
  var moreToggle         = document.getElementById('booking-popup-more-toggle');
  var moreContent        = document.getElementById('booking-popup-more-content');
  var faqToggle          = document.getElementById('booking-popup-faq-toggle');
  var faqContent         = document.getElementById('booking-popup-faq-content');
  var lastFocusedEl      = null;

  /* Duration buttons */
  DURATIONS.forEach(function (opt, i) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'booking-popup__duration-btn' + (i === 0 ? ' is-selected' : '');
    btn.textContent = opt.label + (opt.price ? ' — ' + opt.price : '');
    btn.addEventListener('click', function () { selectDuration(i); });
    durationsContainer.appendChild(btn);
  });

  /* Persons buttons */
  PERSONS_OPTIONS.forEach(function (val, i) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'booking-popup__duration-btn' + (i === 0 ? ' is-selected' : '');
    btn.textContent = val;
    btn.addEventListener('click', function () { selectPersons(val, btn); });
    personsContainer.appendChild(btn);
  });

  /* FAQ items */
  FAQ_ITEMS.forEach(function (item) {
    var wrapper  = document.createElement('div');
    wrapper.className = 'booking-popup__faq-item';

    var question = document.createElement('button');
    question.type = 'button';
    question.className = 'booking-popup__faq-question';
    question.setAttribute('aria-expanded', 'false');
    question.innerHTML = item.q + ' <span class="booking-popup__faq-arrow" aria-hidden="true">&#9660;</span>';

    var answer = document.createElement('div');
    answer.className = 'booking-popup__faq-answer';
    answer.hidden = true;
    answer.textContent = item.a;

    question.addEventListener('click', function () {
      var isOpen = !answer.hidden;
      answer.hidden = isOpen;
      question.setAttribute('aria-expanded', String(!isOpen));
      question.classList.toggle('is-open', !isOpen);
    });

    wrapper.appendChild(question);
    wrapper.appendChild(answer);
    faqContainer.appendChild(wrapper);
  });

  function updateWaLink() {
    var opt = DURATIONS[selectedDurationIndex];
    var msg = 'Hi, I would like to book the ' + opt.message + '. Number of persons: ' + selectedPersons + '. Is it available?';
    waBtn.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
  }

  function selectDuration(index) {
    selectedDurationIndex = index;
    var opt = DURATIONS[index];
    durationsContainer.querySelectorAll('.booking-popup__duration-btn').forEach(function (btn, i) {
      btn.classList.toggle('is-selected', i === index);
    });
        priceEl.innerHTML = opt.price ? opt.price + '<span>per jetski</span>' : 'Price on request';
    var extraNote = document.getElementById('booking-popup-extra-note');
    if (extraNote) extraNote.innerHTML = opt.min2 ? 'Minimum of 2 jetskis' : '+ &euro;25 per extra person per jetski';
    updateWaLink();
  }

  function selectPersons(val, clicked) {
    selectedPersons = val;
    personsContainer.querySelectorAll('.booking-popup__duration-btn').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn === clicked);
    });
    updateWaLink();
  }

  /* More information toggle */
  moreToggle.addEventListener('click', function () {
    var isOpen = !moreContent.hidden;
    moreContent.hidden = isOpen;
    moreToggle.setAttribute('aria-expanded', String(!isOpen));
    moreToggle.classList.toggle('is-open', !isOpen);
  });

  /* FAQ outer toggle */
  faqToggle.addEventListener('click', function () {
    var isOpen = !faqContent.hidden;
    faqContent.hidden = isOpen;
    faqToggle.setAttribute('aria-expanded', String(!isOpen));
    faqToggle.classList.toggle('is-open', !isOpen);
  });

  selectDuration(0);

  /* Globale opener zodat de header de popup met voorselectie kan openen */
  window.openBookingPopup = function (index) {
    if (typeof index === 'number' && DURATIONS[index]) selectDuration(index);
    openPopup();
  };
  function openPopup() {
    lastFocusedEl = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocusedEl) lastFocusedEl.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-booking-popup]')) {
      openPopup();
    }
  });

  closeBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closePopup();
    }
  });

  /* Cursor glow
     ======================================================================== */
  (function () {
    if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

    var glow = document.createElement('div');
    glow.className = 'cursor-glow';
    document.body.appendChild(glow);

    document.addEventListener('mousemove', function (e) {
      glow.style.transform = 'translate(' + (e.clientX - glow.offsetWidth / 2) + 'px, ' + (e.clientY - glow.offsetHeight / 2) + 'px)';
    });

    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, [role="button"]')) {
        glow.classList.add('is-hovering');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('a, button, [role="button"]')) {
        glow.classList.remove('is-hovering');
      }
    });
  }());
})();

(function(){
  var cards = document.querySelectorAll('.tour-card');
  if(!cards.length || !('IntersectionObserver' in window)) {
    cards.forEach(function(c){ c.classList.add('is-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  cards.forEach(function(c){ observer.observe(c); });
})();

(function(){
  var reveals = document.querySelectorAll('.stays-reveal');
  if(!reveals.length || !('IntersectionObserver' in window)) {
    reveals.forEach(function(el){ el.classList.add('is-revealed'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(function(el){ observer.observe(el); });
})();

(function(){
  var rctaEls = document.querySelectorAll('.rcta-reveal');
  if(!rctaEls.length || !('IntersectionObserver' in window)) {
    rctaEls.forEach(function(el){ el.classList.add('is-revealed'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  rctaEls.forEach(function(el){ observer.observe(el); });
})();

// Product cards pop-in (tours page)
document.querySelectorAll('.product-card').forEach(card => {
  new IntersectionObserver(([e]) => {
    if (e.isIntersecting) { card.classList.add('is-visible'); }
  }, { threshold: 0.1 }).observe(card);
});